import React, { useState } from 'react';
// --- IMPORTA TU FUNCIÓN API ---
import { createLead } from '../api/api'; // Asegúrate que la ruta sea correcta
import './LandingPage.css'; // <--- IMPORTA EL CSS AQUÍ

// --- Componente LandingPage ---
function LandingPage() {
  // Estado para los campos del formulario y el checkbox de consentimiento
  const [formData, setFormData] = useState({
    name: '',
    phone: ''
  });
  const [consentChecked, setConsentChecked] = useState(false);
  const [formMessage, setFormMessage] = useState({ type: '', text: '' }); // Para mensajes de error o éxito
  const [loading, setLoading] = useState(false); // Estado para indicar carga

  // Manejador para cambios en los inputs del formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  // Manejador para el cambio en el checkbox
  const handleCheckboxChange = (e) => {
    setConsentChecked(e.target.checked);
    // Limpiar mensaje de error si el usuario marca la casilla
    if (e.target.checked && formMessage.type === 'error') {
        setFormMessage({ type: '', text: '' });
    }
  };

  // --- handleSubmit MODIFICADO para usar createLead de api.js ---
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevenir recarga de la página
    setFormMessage({ type: '', text: '' }); // Limpiar mensajes previos

    // Validación simple (se mantiene)
    if (!formData.name.trim() || !formData.phone.trim()) {
        setFormMessage({ type: 'error', text: 'Por favor, completa tu nombre y teléfono.' });
        return;
    }
    if (!consentChecked) {
      // Mensaje actualizado para reflejar un solo aviso
      setFormMessage({ type: 'error', text: 'Debes aceptar el Aviso de Privacidad y consentir el contacto para continuar.' });
      return;
    }

    setLoading(true); // Inicia estado de carga
    setFormMessage({ type: 'info', text: 'Enviando...' }); // Mensaje de carga

    try {
      // --- LLAMADA USANDO createLead de api.js ---
      // La función createLead ya maneja la URL base y lanza errores específicos
      await createLead(formData);

      // --- MANEJO DE ÉXITO ---
      // Si createLead no lanza error, la operación fue exitosa
      setFormMessage({ type: 'success', text: '¡Gracias! Hemos recibido tu solicitud. Pronto te contactaremos vía WhatsApp.' });
      setFormData({ name: '', phone: '' }); // Limpiar formulario
      setConsentChecked(false); // Desmarcar checkbox

    } catch (error) {
      // --- MANEJO DE ERRORES (provenientes de api.js) ---
      // La función createLead en api.js ya debería haber formateado el mensaje de error
      // console.error('Error al crear lead (desde LandingPage):', error); // Eliminado
      setFormMessage({
          type: 'error',
          // Usa el mensaje del error lanzado por api.js, o uno genérico si no existe
          text: error.message || 'Hubo un problema al enviar tu solicitud. Por favor, intenta de nuevo más tarde.'
      });
    } finally {
      setLoading(false); // Termina estado de carga, independientemente del resultado
    }
  };

  // --- JSX de la Landing Page (sin cambios estructurales) ---
  return (
    <div className="landing-container">
      {/* --- Sección Principal (Hero) --- */}
      <header className="landing-hero">
        <h1>¿Síntomas Mamarios preocupantes? Obtén una Consulta Inicial Gratuita.</h1>
        <p>
          Ofrecemos una consulta de exploración mamaria <strong>sin costo</strong> y una <strong>ruta diagnóstica acelerada</strong> para mujeres que ya presentan síntomas. Tu primer paso hacia la tranquilidad y un diagnóstico oportuno.
        </p>
        <a href="#formulario-contacto" className="landing-button">Solicita tu Consulta Gratuita Ahora</a>
      </header>

      {/* --- Sección Problema/Necesidad --- */}
      <section className="landing-section">
        <h2>Si tienes Síntomas, el Tiempo es Clave</h2>
        <p>Descubrir un bulto, dolor persistente, secreción o cambios en la piel de tus senos genera una lógica preocupación. Sabemos que la incertidumbre y los largos tiempos de espera para obtener un diagnóstico en el sistema de salud pueden aumentar la ansiedad.</p>
        <p>El Programa VIKI está diseñado <strong>específicamente para mujeres como tú</strong>, que ya tienen síntomas y necesitan una evaluación y diagnóstico <strong>oportunos</strong>.</p>
        <p><strong>No somos un programa de tamizaje anual.</strong> Nos enfocamos en darte una respuesta rápida cuando más la necesitas.</p>
      </section>

      {/* --- Sección Cómo Funciona --- */}
      <section className="landing-section">
        <h2>Tu Ruta hacia la Claridad: Nuestro Proceso Sencillo</h2>
        <ul className="landing-step-list">
          <li className="landing-step-item"><span className="landing-step-icon">📝</span> <strong>Paso 1: Contacto Seguro.</strong> Llena el breve formulario seguro en esta página. Tus datos están protegidos.</li>
          <li className="landing-step-item"><span className="landing-step-icon">📱</span> <strong>Paso 2: Contacto por WhatsApp.</strong> Te contactaremos (con tu permiso explícito) para confirmar tu elegibilidad y agendar tu cita gratuita.</li>
          <li className="landing-step-item"><span className="landing-step-icon">👩‍⚕️</span> <strong>Paso 3: Consulta Inicial Gratuita.</strong> Acude a tu cita. Personal de salud capacitado realizará una historia clínica y exploración mamaria completa, sin costo para ti.</li>
          <li className="landing-step-item"><span className="landing-step-icon">🔬</span> <strong>Paso 4: Diagnóstico Acelerado (Si es Necesario).</strong> Si detectamos algo sospechoso, activamos nuestra ruta rápida: posibilidad de biopsia guiada por imagen el mismo día y análisis de patología expedito (diagnóstico).</li>
          <li className="landing-step-item"><span className="landing-step-icon">➡️</span> <strong>Paso 5: Resultados y Referencia.</strong> Te entregamos los resultados de forma clara y te referimos formalmente a tu sistema de salud (IMSS, ISSSTE, etc.) o médico tratante para el siguiente paso.</li>
        </ul>
      </section>

      {/* --- Sección Beneficios --- */}
      <section className="landing-section">
        <h2>¿Qué Hace Diferente a VIKI?</h2>
        <ul className="landing-benefit-list">
          <li className="landing-benefit-item"><strong>Consulta Inicial 100% Gratuita:</strong> Evaluación profesional por una especialista en detección de cáncer de mama sin costo alguno.</li>
          <li className="landing-benefit-item"><strong>Ruta Diagnóstica Rápida:</strong> Reducimos drásticamente la espera para biopsia y patología en casos sospechosos.</li>
          <li className="landing-benefit-item"><strong>Enfoque Especializado en Síntomas:</strong> Atención diseñada para mujeres que ya notaron cambios y necesitan respuestas.</li>
          <li className="landing-benefit-item"><strong>Diagnóstico Confiable:</strong> Nuestra patología incluye Inmunohistoquímica (IHQ) esencial.</li>
          <li className="landing-benefit-item"><strong>Atención Empática:</strong> Te acompañamos con respeto.</li>
          <li className="landing-benefit-item"><strong>Confidencialidad:</strong> Protegemos tu privacidad (LFPDPP)</li>
           <li className="landing-benefit-item"><strong>Claridad y Transparencia:</strong> Te explicamos cada paso del proceso.</li>
        </ul>
      </section>

      {/* --- Sección ¿Para Quién? --- */}
      <section className="landing-section">
         <h2>Confirmando si VIKI es tu Mejor Opción</h2>
         <div className="landing-who-section">
            <div className="landing-who-box landing-who-yes">
                <h3>Este programa SÍ es para ti si:</h3>
                <ul>
                    <li>Has detectado síntomas como: bulto/masa, dolor persistente, secreción anormal, cambios en piel, cambio reciente en tamaño/forma.</li>
                    <li>Estás preocupada por estos síntomas y buscas una evaluación diagnóstica.</li>
                    <li>Tu mastografía resultó con BIRADS 4, 5 ó 0.</li>

                </ul>
            </div>
            <div className="landing-who-box landing-who-no">
                 <h3>Este programa NO es para ti si:</h3>
                <ul>
                    <li><strong>No tienes ningún síntoma</strong> y buscas un chequeo preventivo anual o mastografía de tamizaje. <strong>Continúa con la prevención, acude a las opciones de tu institución de salud</strong>. (Más información aquí)</li>
                    <li>Ya estás en tratamiento oncológico activo por cáncer de mama.</li>
                </ul>
            </div>
         </div>
      </section>

       {/* --- Sección Confianza/Credibilidad --- */}
      <section className="landing-section">
        <h2>Tu Confianza es Nuestra Prioridad</h2>
         <ul>
            <li>Tu atención está a cargo de médicas especialistas en Diagnóstico de Cáncer de Mama.</li>
            <li>Procedimientos diagnósticos (biopsia, patología) realizados por médicas especialistas certificadas.</li>
            {/* Descomentar cuando tengas el número */}
            {/* <li className="landing-cofepris">Publicidad registrada ante COFEPRIS. [No. de Aviso/Permiso: XXXXXX]</li> */}
            <li className="landing-cofepris">Compromiso con la normatividad sanitaria aplicable.</li>
         </ul>
      </section>

      {/* ================================================================== */}
      {/* ============ INICIO NUEVA SECCIÓN: ESPECIALISTAS CAMPAÑA ========= */}
      {/* ================================================================== */}
      <section className="landing-section team-section-landing"> {/* Usa clases existentes o crea nuevas en LandingPage.css */}
          <h2>Conoce a Nuestras Especialistas Dedicadas a la Campaña</h2>
          <p>Un equipo de salud altamente calificado, listas para brindarte la mejor atención.</p>
          <div className="specialists-landing-container"> {/* Necesitarás estilos para este contenedor (ej. display: flex) */}
              {/* --- Especialista 1 (Activa) --- */}
              <div className="specialist-card-landing"> {/* Estilos para la tarjeta */}
                  <img
                      src="/images/team/generic.jpeg" // <-- CAMBIA ESTO por el nombre real
                      alt="Foto Dra. Raquel Navarro" // <-- CAMBIA ESTO
                      className="specialist-photo-landing" // Estilos para la foto
                      onError={(e) => { e.target.onerror = null; e.target.src="/images/team/generic.jpeg"; }} // Fallback genérico
                  />
                  <h3>Dra. Raquel Navarro</h3> {/* <-- CAMBIA ESTO */}
                  <p>Especialista en Patología Oncológica</p> {/* <-- CAMBIA ESTO */}
              </div>
              {/* --- Especialista 2 (Activa) --- */}
              <div className="specialist-card-landing">
                  <img
                      src="/images/team/generic.jpeg" // <-- CAMBIA ESTO por el nombre real
                      alt="Foto Dra. [Nombre Apellido 2]" // <-- CAMBIA ESTO
                      className="specialist-photo-landing"
                      onError={(e) => { e.target.onerror = null; e.target.src="/images/team/generic.jpeg"; }} // Fallback genérico
                  />
                  <h3>Dra. [Nombre Apellido 2]</h3> {/* <-- CAMBIA ESTO */}
                  <p>[Especialidad Principal 2]</p> {/* <-- CAMBIA ESTO */}
              </div>
              {/* --- Especialista 3 (Activa) --- */}
              <div className="specialist-card-landing">
                  <img
                      src="/images/team/generic.jpeg" // <-- CAMBIA ESTO por el nombre real
                      alt="Foto Ft. Adriana Cruz Sánchez" // <-- CAMBIA ESTO
                      className="specialist-photo-landing"
                      onError={(e) => { e.target.onerror = null; e.target.src="/images/team/generic.jpeg"; }} // Fallback genérico
                  />
                  <h3>Ft. Adriana Cruz Sánchez</h3> {/* <-- CAMBIA ESTO */}
                  <p>Especialidad en Rehabilitación Oncológica</p> {/* <-- CAMBIA ESTO */}
              </div>
          </div>
          {/* --- Enlace a la página completa del equipo --- */}
          {/* Asegúrate que la ruta '/TeamPage' sea correcta según tu router */}
          <a href="/TeamPage" className="landing-button team-link-button"> {/* Reutiliza clase o crea una nueva */}
              Conoce al Equipo Completo de Especialistas
          </a>
      </section>
      {/* ================================================================== */}
      {/* ============= FIN NUEVA SECCIÓN: ESPECIALISTAS CAMPAÑA =========== */}
      {/* ================================================================== */}


      {/* --- Sección CTA Final y Formulario --- */}
      <section id="formulario-contacto" className="landing-section landing-form-section">
        <h2>¿Lista para Obtener Claridad? Solicita tu Consulta Gratuita</h2>
        <p>Llena el siguiente formulario seguro. Es el primer paso hacia tu evaluación. Recuerda, la consulta inicial de exploración es <strong>completamente gratuita</strong>.</p>

        <form onSubmit={handleSubmit} className="landing-form">
          <div className="landing-form-group">
            <label htmlFor="name" className="landing-label">Nombre Completo:</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="landing-input"
              disabled={loading} // Deshabilita input mientras carga
            />
          </div>
          <div className="landing-form-group">
            <label htmlFor="phone" className="landing-label">Teléfono (WhatsApp):</label>
            <input
              type="tel" // Usar 'tel' para semántica y teclados móviles
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="Ej: 55 1234 5678"
              className="landing-input"
              disabled={loading} // Deshabilita input mientras carga
            />
             <small>Te contactaremos por este medio para agendar.</small>
          </div>

          {/* Mensajes de error, éxito o información */}
          {formMessage.text && (
            <p className={`landing-message ${
                formMessage.type === 'error' ? 'landing-error' :
                formMessage.type === 'success' ? 'landing-success' :
                'landing-info' // Clase para mensaje 'Enviando...'
            }`}>
                {formMessage.text}
            </p>
          )}

          {/* --- GRUPO DE CONSENTIMIENTO MODIFICADO --- */}
          <div className="landing-consent-group">
             <input
              type="checkbox"
              id="consent"
              name="consent"
              checked={consentChecked}
              onChange={handleCheckboxChange}
              required
              className="landing-checkbox"
              disabled={loading} // Deshabilita checkbox mientras carga
            />
            <label htmlFor="consent">
              {/* Texto actualizado para apuntar a un solo aviso */}
              {/* Asegúrate que la ruta '/aviso-privacidad' sea correcta según tu router */}
              <strong>* Obligatorio:</strong> He leído y acepto el <a href="/aviso-privacidad" target="_blank" rel="noopener noreferrer" className="landing-consent-link">Aviso de Privacidad</a>. Consiento el tratamiento de mis datos (Nombre, Teléfono) para ser contactada, informada y agendada en el Programa VIKI. Consiento expresamente ser contactada vía WhatsApp para estos fines. Consiento el tratamiento de mis datos sensibles (motivo de consulta/síntomas) conforme al Aviso de Privacidad, para evaluar mi elegibilidad para la consulta gratuita.
            </label>
          </div>
          {/* --- FIN GRUPO DE CONSENTIMIENTO MODIFICADO --- */}

          <button type="submit" className="landing-button" disabled={loading}> {/* Deshabilita botón mientras carga */}
            {loading ? 'Enviando...' : 'Enviar Solicitud Ahora'} {/* Cambia texto del botón */}
          </button>
        </form>
      </section>

      {/* --- Pie de Página MODIFICADO --- */}
      <footer className="landing-footer">
        <p>
          {/* Se elimina el enlace al aviso simplificado y se actualiza el enlace restante */}
          {/* Asegúrate que la ruta '/aviso-privacidad' sea correcta según tu router */}
          <a href="/aviso-privacidad" target="_blank" rel="noopener noreferrer" className="landing-footer-link">Aviso de Privacidad</a>
          {/* Puedes añadir aquí el enlace a Términos y Condiciones si lo tienes */}
          {/* | <a href="/terminos-condiciones" target="_blank" rel="noopener noreferrer" className="landing-footer-link">Términos y Condiciones</a> */}
        </p>
        <p>Programa de Diagnóstico Abreviado Acelerado - CDMX (VIKI)</p>
        <p>© {new Date().getFullYear()} Todos los derechos reservados.</p>
        {/* Descomentar cuando tengas el número */}
        {/* <p className="landing-cofepris">COFEPRIS Aviso/Permiso No: XXXXXX</p> */}
         <p className="landing-note">
            Nota Importante: La información en esta página es orientativa y no sustituye una consulta médica profesional. El programa VIKI ofrece una ruta diagnóstica, no tratamiento oncológico.
         </p>
      </footer>
      {/* --- FIN Pie de Página MODIFICADO --- */}
    </div>
  );
}

export default LandingPage;
